import { Snackbar, Box, Typography, LinearProgress } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { useVersionCheck } from '../hooks/useVersionCheck';

const UpdateBanner = () => {
  const { updateAvailable, countdown } = useVersionCheck();

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 70, md: 24 } }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 1.5,
          borderRadius: 2,
          backgroundColor: '#1a237e',
          color: '#fff',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          minWidth: 300,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
          <SystemUpdateAltIcon sx={{ fontSize: 22 }} />
          <Typography variant="body2" sx={{ fontWeight: 600, flex: 1 }}>
            New version available — reloading in {countdown}s
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={((3 - countdown) / 3) * 100}
          sx={{
            height: 4,
            borderRadius: 2,
            backgroundColor: 'rgba(255,255,255,0.2)',
            '& .MuiLinearProgress-bar': { backgroundColor: '#69f0ae' },
          }}
        />
      </Box>
    </Snackbar>
  );
};

export default UpdateBanner;
